import { Route, Routes } from 'react-router-dom'
import { isMultilangPocEnabled } from '../../../constants/featureFlags'
import ErrorPage, { ErrorType } from '../../../controls/ErrorPage'
import { WaveAudiencesPage } from './WaveAudiencesPage'
import { WaveConfirmPage } from './WaveConfirmPage'
import { WaveDedupPage } from './WaveDedupPage'
import { WavePage } from './WavePage'
import { WaveQuestionnaireGuard } from './WaveQuestionnaireGuard'
import { WaveStepPlaceholder } from './WaveStepPlaceholder'
import { WaveSurveyPage } from './WaveSurveyPage'
import { WaveTranslationsPage } from './WaveTranslationsPage'

/**
 * One wave's steps, at /project/:projectId/wave/:waveId. Audiences, Survey and
 * Translations are the multi-market screens, each scoped to the wave's markets
 * and its own questionnaire.
 */
export const WaveRoutes = () => {
  return (
    <WaveQuestionnaireGuard>
      <Routes>
        <Route index element={<WavePage />} />

        <Route path="audiences" element={<WaveAudiencesPage />} />
        <Route path="audiences/:surveyId" element={<WaveAudiencesPage />} />

        <Route path="survey" element={<WaveSurveyPage />} />

        <Route path="dedup" element={<WaveDedupPage />} />

        {/* Same gate as the multi-market flow: the translations editor is behind
          the multi-language POC flag, and WaveFlowBreadcrumb drops the step
          alongside it so it never links to a 404. */}
        {isMultilangPocEnabled() && (
          <Route path="translations" element={<WaveTranslationsPage />} />
        )}
        <Route
          path="tracking"
          element={<WaveStepPlaceholder step="Tracking" />}
        />
        <Route path="confirm" element={<WaveConfirmPage />} />

        <Route
          path="*"
          element={<ErrorPage errorType={ErrorType.NotFound404} />}
        />
      </Routes>
    </WaveQuestionnaireGuard>
  )
}
